const transferSyntaxes = {
    IMPLICIT_VR_LITTLE_ENDIAN: '1.2.840.10008.1.2',
    EXPLICIT_VR_LITTLE_ENDIAN: '1.2.840.10008.1.2.1',
    ENCAPSULATED_UNCOMPRESSED_EXPLICIT_VR_LITTLE_ENDIAN: '1.2.840.10008.1.2.1.98',
    DEFLATED_EXPLICIT_VR_LITTLE_ENDIAN: '1.2.840.10008.1.2.1.99',
    EXPLICIT_VR_BIG_ENDIAN: '1.2.840.10008.1.2.2',
    JPEG_BASELINE_PROCESS_1: '1.2.840.10008.1.2.4.50',
    JPEG_EXTENDED_PROCESS_2_4: '1.2.840.10008.1.2.4.51',
    JPEG_EXTENDED_PROCESSES_3_5: '1.2.840.10008.1.2.4.52',
    JPEG_SPECTRAL_SELECTION_NONHIERARCHICAL_PROCESSES_6_8: '1.2.840.10008.1.2.4.53',
    JPEG_SPECTRAL_SELECTION_NONHIERARCHICAL_PROCESSES_7_9: '1.2.840.10008.1.2.4.54',
    JPEG_FULL_PROGRESSION_NONHIERARCHICAL_PROCESSES_10_12: '1.2.840.10008.1.2.4.55',
    JPEG_FULL_PROGRESSION_NONHIERARCHICAL_PROCESSES_11_13: '1.2.840.10008.1.2.4.56',
    JPEG_LOSSLESS_NONHIERARCHICAL_PROCESS_14: '1.2.840.10008.1.2.4.57',
    JPEG_LOSSLESS_NONHIERARCHICAL_PROCESS_15: '1.2.840.10008.1.2.4.58',
    JPEG_EXTENDED_HIERARCHICAL_PROCESSES_16_18: '1.2.840.10008.1.2.4.59',
    JPEG_EXTENDED_HIERARCHICAL_PROCESSES_17_19: '1.2.840.10008.1.2.4.60',
    JPEG_SPECTRAL_SELECTION_HIERARCHICAL_PROCESSES_20_22: '1.2.840.10008.1.2.4.61',
    JPEG_SPECTRAL_SELECTION_HIERARCHICAL_PROCESSES_21_23: '1.2.840.10008.1.2.4.62',
    JPEG_FULL_PROGRESSION_HIERARCHICAL_PROCESSES_24_26: '1.2.840.10008.1.2.4.63',
    JPEG_FULL_PROGRESSION_HIERARCHICAL_PROCESSES_25_27: '1.2.840.10008.1.2.4.64',
    JPEG_LOSSLESS_NONHIERARCHICAL_PROCESS_28: '1.2.840.10008.1.2.4.65',
    JPEG_LOSSLESS_NONHIERARCHICAL_PROCESS_29: '1.2.840.10008.1.2.4.66',
    JPEG_LOSSLESS_NONHIERARCHICAL_FIRST_ORDER_PREDICTION_PROCESS_14: '1.2.840.10008.1.2.4.70',
    JPEG_LS_LOSSLESS_IMAGE_COMPRESSION: '1.2.840.10008.1.2.4.80',
    JPEG_LS_LOSSY_NEAR_LOSSLESS_IMAGE_COMPRESSION: '1.2.840.10008.1.2.4.81',
    JPEG_2000_IMAGE_COMPRESSION_LOSSLESS_ONLY: '1.2.840.10008.1.2.4.90',
    JPEG_2000_IMAGE_COMPRESSION: '1.2.840.10008.1.2.4.91',
    JPEG_2000_PART_2_MULTICOMPONENT_IMAGE_COMPRESSION_LOSSLESS_ONLY: '1.2.840.10008.1.2.4.92',
    JPEG_2000_PART_2_MULTICOMPONENT_IMAGE_COMPRESSION: '1.2.840.10008.1.2.4.93',
    JPIP_REFERENCED: '1.2.840.10008.1.2.4.94',
    JPIP_REFERENCED_DEFLATE: '1.2.840.10008.1.2.4.95',
    MPEG2_MAIN_PROFILE_MAIN_LEVEL: '1.2.840.10008.1.2.4.100',
    MPEG4_AVC_H264_HIGH_PROFILE_LEVEL_4_1: '1.2.840.10008.1.2.4.101',
    MPEG4_AVC_H264_BD_COMPATIBLE_HIGH_PROFILE_LEVEL_4_1: '1.2.840.10008.1.2.4.102',
    MPEG4_AVC_H264_HIGH_PROFILE_FOR_2D_VIDEO: '1.2.840.10008.1.2.4.103',
    MPEG4_AVC_H264_HIGH_PROFILE_FOR_3D_VIDEO: '1.2.840.10008.1.2.4.104',
    JPIP_LOSSLESS: '1.2.840.10008.1.2.4.96',
    JPIP_PART2_MULTICOMPONENT_IMAGE_COMPRESSION: '1.2.840.10008.1.2.4.97',
    JPEG_XL_LOSSLESS: '1.2.840.10008.1.2.4.110',
    JPEG_XL_JPEG_RECOMPRESSION: '1.2.840.10008.1.2.4.111',
    JPEG_XL: '1.2.840.10008.1.2.4.112',
    RFC_2557_MIME_ENCAPSULATION: '1.2.840.10008.1.2.6.1',
    JPEG_XR_IMAGE_COMPRESSION: '1.2.840.10008.1.2.6.2',
    JPEG_2000_IMAGE_COMPRESSION_LOSSLESS_ONLY_RETIRED: '1.2.840.10008.1.2.4.90R',
    JPEG_2000_IMAGE_COMPRESSION_RETIRED: '1.2.840.10008.1.2.4.91R',
    JPEG_2000_PART_2_MULTICOMPONENT_IMAGE_COMPRESSION_LOSSLESS_ONLY_RETIRED: '1.2.840.10008.1.2.4.92R',
    JPEG_2000_PART_2_MULTICOMPONENT_IMAGE_COMPRESSION_RETIRED: '1.2.840.10008.1.2.4.93R',
    DEFLATED_IMAGE_FRAME_COMPRESSION: '1.2.840.10008.1.2.8.1',
};
export default transferSyntaxes;
